var _rect, _rect2, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkdinBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 40,
    viewBox: "0 0 42 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 41,
    height: 39,
    rx: 8.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 41,
    height: 39,
    rx: 8.5,
    stroke: "#CCCCCC"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6637_43699)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_6637_43699)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.2008 12.2031C12.8133 12.2031 11.8039 13.0359 11.8039 14.1797C11.8039 15.3281 12.8367 16.1953 14.2008 16.1953C15.5883 16.1953 16.5961 15.3484 16.5961 14.1563C16.5336 13.0078 15.5445 12.2031 14.2008 12.2031ZM12.2008 17C11.9805 17 11.8008 17.1797 11.8008 17.4V29C11.8008 29.2203 11.9805 29.4 12.2008 29.4H16.2008C16.4211 29.4 16.6008 29.2203 16.6008 29V17.4C16.6008 17.1797 16.4211 17 16.2008 17H12.2008ZM18.2008 17C17.9805 17 17.8008 17.1797 17.8008 17.4V29C17.8008 29.2203 17.9805 29.4 18.2008 29.4H21.8008C22.0211 29.4 22.2008 29.2203 22.2008 29V22.8C22.2008 21.8516 22.9289 21.0797 23.857 21.0078C23.9055 21 23.9523 21 24.0008 21C24.0492 21 24.0961 21 24.1445 21.0078C25.0727 21.0797 25.8008 21.8516 25.8008 22.8V29C25.8008 29.2203 25.9805 29.4 26.2008 29.4H29.8008C30.0211 29.4 30.2008 29.2203 30.2008 29V22.2C30.2008 19.6125 28.8117 17 25.7164 17C24.3086 17 23.2445 17.5438 22.6008 17.9953V17.4C22.6008 17.1797 22.4211 17 22.2008 17H18.2008Z",
    fill: "#0077B5"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6637_43699"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(11 11)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_6637_43699"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(11 11)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkdinBlue);
export default __webpack_public_path__ + "static/media/linkdin-blue.9da181ef208c93cbce3be7a0531a5ecc.svg";
export { ForwardRef as ReactComponent };